import React from 'react';
import { useTranslation } from 'react-i18next';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <li className="nav-item dropdown">
      <a
        className="nav-link dropdown-toggle"
        href="#"
        id="languageDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        🌍 {i18n.language === 'es' ? 'ES' : 'EN'}
      </a>
      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
        <li>
          <button 
            className={`dropdown-item ${i18n.language === 'en' ? 'active' : ''}`}
            onClick={() => changeLanguage('en')}
          >
            English
          </button>
        </li>
        <li>
          <button 
            className={`dropdown-item ${i18n.language === 'es' ? 'active' : ''}`}
            onClick={() => changeLanguage('es')}
          >
            Español
          </button>
        </li>
      </ul>
    </li>
  );
}
